module.exports = __webpack_public_path__ + "images/assets/8dd4016eef803333733ab6e9d40f1ceb.svg";